import React, { useEffect, useState } from "react";
import { AdminContext, AdminUI, Resource, defaultTheme } from "react-admin";

/* I18N Provider  */
import polyglotI18nProvider from "ra-i18n-polyglot";
import frenchMessages from "ra-language-french";

/* Database / DataProvider */
/* Auth / AuthProvider */
import authProvider from "./config/firebaseAuthProvider";

/* Pages */
import CustomLoginPage from "./pages/LoginPage";
import RedirectToLoginPage from "./pages/RedirectToLoginPage";

/* Layout */
import Layout from "./layout/Layout";

/* Hooks */
import useFirebaseAuth from "./hooks/useFirebaseAuth";

import customRoutes from "./customRoutes";
import CustomDashboard from "./components/Dashboard";
import resources from "./resources/index";
import { createDataProvider } from "./config/dataProvider";

const theme = {
	...defaultTheme,
	palette: {
		primary: {
			light: "#a60012",
			main: "#a60012",
			dark: "#a60012",
		},
	},
};

const i18nProvider = polyglotI18nProvider(() => frenchMessages, "fr");

const App = () => {
	const [dataProvider, setDataProvider] = useState(null);
	const { user, isLoading } = useFirebaseAuth();

	useEffect(() => {
		if (!user) return;

		const generateToken = (force = false) => {
			return user
				.getIdToken(force)
				.then((token) => {
					localStorage.setItem("token", token);
					return token;
				})
				.catch((error) => {
					console.log("Failed to get token: ", error);
				});
		};

		generateToken().then(async (token) => {
			const hasuraDataProvider = await createDataProvider(token);

			setDataProvider(() => hasuraDataProvider);
		});

		// Every 10minutes, reload and refresh the user token.
		// This is a hotfix to maintain the user connected.
		const interval = setInterval(async () => {
			generateToken(true);
		}, 1000 * 60 * 10);

		return () => {
			clearInterval(interval);
		};
	}, [user]);

	if (isLoading || (!isLoading && !!user && !dataProvider)) {
		return <p>Chargement...</p>;
	}

	if (!user) {
		return <RedirectToLoginPage />;
	}

	return (
		<AdminContext
			dataProvider={dataProvider}
			authProvider={authProvider}
			i18nProvider={i18nProvider}
			theme={theme}
		>
			<AdminUI
				title="OMF Crowdfunding admin"
				layout={Layout}
				// customRoutes={customRoutes}
				loginPage={CustomLoginPage}
				dashboard={CustomDashboard}
				requireAuth
				ready={!!user}
			>
				{resources.map((resourceProps) => (
					<Resource name={resourceProps.name} key={resourceProps.name} {...resourceProps} />
				))}
			</AdminUI>
		</AdminContext>
	);
};

export default App;
